import { Link, useNavigate } from "react-router-dom";
import { Logo } from "@/components/brand/Logo";
import { Mail, MapPin, Phone, LifeBuoy } from "lucide-react";

export default function PublicFooter() {
  const navigate = useNavigate();
  const cols = [
    {
      title: "Product",
      links: [
        ["Features", "/features"],
        ["Solutions", "/solutions"],
        ["Pricing", "/pricing"],
        ["How It Works", "/#how-it-works"],
        ["Request a Demo", "/request-demo"],
      ],
    },
    {
      title: "Capabilities",
      links: [
        ["Fleet & Driver Management", "/features#fleet"],
        ["Safety & Accountability", "/features#safety"],
        ["Dispatch & Live GPS", "/features#dispatch"],
        ["Compliance Tracking", "/features#compliance"],
      ],
    },
    {
      title: "Company",
      links: [
        ["About", "/about"],
        ["Contact", "/contact"],
        ["Privacy Policy", "/privacy"],
        ["Terms of Service", "/terms"],
        ["Login", "/login"],
      ],
    },
  ];

  return (
    <footer className="bg-slate-950 text-slate-300" data-testid="public-footer">
      <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
        <div className="grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
          <div>
            <Logo variant="light" />
            <p className="mt-5 max-w-xs text-sm leading-relaxed text-slate-400">
              The operations and accountability platform for non-emergency and non-medical
              transportation providers.
            </p>
            <div className="mt-6 space-y-2 text-sm text-slate-400">
              <a href="mailto:hello@myridestamp.com" data-testid="footer-contact-email" className="flex items-center gap-2.5 hover:text-white"><Mail className="h-4 w-4 text-blue-400" /> hello@myridestamp.com</a>
              <a href="mailto:support@myridestamp.com" data-testid="footer-support-email" className="flex items-center gap-2.5 hover:text-white"><LifeBuoy className="h-4 w-4 text-blue-400" /> support@myridestamp.com</a>
              <div className="flex items-center gap-2.5"><Phone className="h-4 w-4 text-blue-400" /> (339) 234-4636</div>
              <div className="flex items-center gap-2.5"><MapPin className="h-4 w-4 text-blue-400" /> United States</div>
            </div>
          </div>
          {cols.map((c) => (
            <div key={c.title}>
              <h4 className="font-display text-sm font-bold uppercase tracking-wider text-white">{c.title}</h4>
              <ul className="mt-4 space-y-3">
                {c.links.map(([label, to]) => (
                  <li key={label}>
                    <button
                      onClick={() => navigate(to.includes("#") ? to.split("#")[0] : to)}
                      className="text-sm text-slate-400 transition-colors hover:text-white"
                    >
                      {label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
        <div className="mt-14 flex flex-col items-center justify-between gap-3 border-t border-slate-800 pt-7 text-sm text-slate-500 sm:flex-row">
          <p>© {new Date().getFullYear()} Kavuma Technologies LLC. All rights reserved.</p>
          <p className="font-mono-data text-xs tracking-tight text-slate-600">
            Every ride. Every driver. Every vehicle. Accounted for.
          </p>
        </div>
      </div>
    </footer>
  );
}
